import MedicalTeamComment from 'src/components/medical-team-comments/medical-team-comments.component'
import { useDashboard } from '../dashboard.provider'
import { useTranslation } from 'react-i18next'
import type { TMedicalTeamComment } from 'src/components/medical-team-comments/medical-team-comments.type'
import { useQueryClient } from '@tanstack/react-query'
import type { TDashboardPatientOverview } from '../dashboard.type'

const DashboardMedicalTeamComment = ({
  medicalTeamComments,
}: {
  medicalTeamComments: TMedicalTeamComment[]
}) => {
  const { t } = useTranslation()
  const { selectedPatientMedEvent } = useDashboard()
  const selectedPatientMedEventId = Number(selectedPatientMedEvent?.id)
  const queryClient = useQueryClient()

  const onUpdateMedicalTeamComment = (
    patientId: number,
    updatedMedicalTeamCommentList: TMedicalTeamComment[],
  ) => {
    if (patientId === selectedPatientMedEvent?.Patient?.id) {
      queryClient.setQueryData(
        ['dashboard-patient-med-event', selectedPatientMedEventId],
        (oldData: TDashboardPatientOverview | undefined) => {
          if (!oldData) return
          return {
            ...oldData,
            medicalTeamComments: updatedMedicalTeamCommentList,
          }
        },
      )
    }
  }

  return (
    <div className="c-flex c-flex-col c-flex-grow">
      <h2 className="c-text-lg c-font-bold c-tracking-wider c-mb-2">
        {t('components.medical-team-comments.title')}
      </h2>
      <div className="c-flex-grow c-pb-10">
        {selectedPatientMedEvent?.Patient?.id && medicalTeamComments && (
          <MedicalTeamComment
            patientId={selectedPatientMedEvent?.Patient?.id}
            medicalTeamComments={medicalTeamComments}
            onUpdateMedicalTeamComment={onUpdateMedicalTeamComment}
            patientMedEventId={selectedPatientMedEventId}
            patientFollowupId={selectedPatientMedEvent.PatientFollowupId}
          />
        )}
      </div>
    </div>
  )
}

export default DashboardMedicalTeamComment
